import GraphqlBuilder from 'utils/request/graphql/builder'
import _ from 'lodash'
import QueryTableUpdatedAt from "graphql/queries/QueryTableUpdatedAt";
import store from 'services/redux/store'
import { dataConstants } from 'services/redux/data/constants'
import HelperPlatform from 'utils/helper-platform'

export default class FetchUpdatedAt {
	
	static firstCallProcessed = false;
	
	static fetch( { tables, parameters, callbackSuccess = null, callbackError = null, callbackStart = null, callbackCancelled = false } = {} ) {
		if( HelperPlatform.isWeb() && this.firstCallProcessed === true && store.getState().data[ dataConstants.APP_IS_FOCUSED ] === false ) {
			if( _.isFunction( callbackCancelled ) ){
				callbackCancelled();
			}
			return;
		}
		
		new GraphqlBuilder()
			.addQuery( 'tables_updated_at', QueryTableUpdatedAt, { tables: tables, parameters: parameters } )
			.setResultPath( [ 'tables_updated_at', 'tables_updated_at' ], [] )
			.setOnStart( callbackStart )
			.setOnError( callbackError )
			.setOnSuccess( result => {
				this.firstCallProcessed = true;
				
				if( callbackSuccess !== null && _.isFunction( callbackSuccess ) ) {
					callbackSuccess( { updated_ats: result } );
				}
			})
			.execute();
	}
}
